// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app__veranstaltungen_main-container {
    max-width: 1200px;
    margin: auto;
    padding: 50px;
}
  
  .app__veranstaltungen_container {
    padding: 30px;
    border-radius: 15px; 
  }
  
  .app__veranstaltungen_title {
    font-size: 3rem;
    color: #000000;
    text-align: center;
    font-family: "SawtonIndustrial-Medium";
  }
  .app__veranstaltungen_button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px;
  }
  .app__veranstaltungen_button {
    background-color: var(--color-blue);
    color: var(--color-creme);
    border: none;
    padding: 10px 20px;
    text-align: center;
    margin: 15px;
    font-size: 1.2em;
    cursor: pointer;
    border-radius: 15px;
    transition: background-color 0.3s, transform 0.2s, box-shadow 0.2s;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);  /* Schatten hinzufügen */
}
.app__veranstaltungen_button.active {
  background-color: var(--color-little-extra);  /* Ändern Sie die Hintergrundfarbe des aktiven Buttons */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);  /* Verstärkter Schatten für den aktiven Button */
}


.app__veranstaltungen_button:hover {
    background-color: var(--color-marone);  /* Farbänderung beim Überfahren */
    transform: scale(1.04) translateY(-3px);  /* leichtes Anheben des Buttons */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);  /* Schattenverstärkung */
}

.app__veranstaltungen_button:active {
    transform: scale(1) translateY(0);  /* Button wird beim Klicken wieder in die Ausgangsposition versetzt */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);  /* Schatten wird wieder normal */
}

  
  .app__veranstaltungen_list {
    list-style-type: none;
    padding: 0;
  }
  
  .app__veranstaltungen_item {
    background: linear-gradient(145deg, var(--color-blue), #233749);
    margin-bottom: 20px;
    padding: 20px;
    border-radius: 15px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
    transition: transform 0.2s;

  }
  
  .app__veranstaltungen_item:hover {
    transform: translateY(-5px);
  }
  
  .app__veranstaltungen_content {
    color: var(--color-creme);
   
  }
  
  .app__veranstaltungen_content h2 {
    display: flex;
    justify-content: space-between;
    font-size: 1.8em;
    margin-bottom: 10px;
    border-bottom: 3px solid var(--color-marone);
  }
  
  .app__veranstaltungen_content div {
    font-size: 1.3em;
    margin-bottom: 5px;
  }
  /* Stil für das Dropdown-Menü */
.app__veranstaltungen_dropdown {
    width: 100%;
    padding: 10px;
    font-size: 1.2em;
    margin-bottom: 20px;
    border-radius: 15px;
    border: 2px solid var(--color-marone);
    background-color: var(--color-blue);
    color: var(--color-creme);
    cursor: pointer;
  }
  
  /* Für das Pfeil-Icon im Dropdown */
  .app__veranstaltungen_dropdown::-ms-expand {
    display: none;  /* Entfernt den Standardpfeil in IE und Edge */
  }
  
  /* Custom Dropdown Pfeil */
  .app__veranstaltungen_dropdown:after {
    content: '\\25BC';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    padding: 0 1em;
    background: var(--color-dark-blue);
    pointer-events: none;
    border-radius: 0 15px 15px 0; /* Abrundung an den Ecken */
  }
  /* Styling Intro-Text Veranstaltungen*/

  .veranstaltung-intro-container {
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 20px;
}

.veranstaltung-intro-title {
    font-size: 1.8em;
    color: var(--color-white);
    font-family:"SawtonCircular-Light";
    text-align: center;
    margin-bottom: 15px;
}

.veranstaltung-intro-text {
    font-size: 1.2em;
    color: var(--color-white);
    font-family:"SawtonCircular-Medium";
    line-height: 1.6;
    text-align: center;
}

 /* Media Queries für Mobilgeräte */
@media screen and (max-width: 768px) {
    .app__veranstaltungen_main-container {
      padding: 20px;
    }
  
    .app__veranstaltungen_container {
      max-width: 100%;
      padding: 20px;
      border-radius: 10px;
    }
  
    .app__veranstaltungen_title {
      font-size: 2em;
      margin-bottom: 20px;
    }
  
    .app__veranstaltungen_button {
      font-size: 1em;
      padding: 8px 20px;
      margin: 10px;
      margin-left: 0;
    }
  
    .app__veranstaltungen_item {
      margin-bottom: 15px;
      padding: 15px;
      border-radius: 10px;
    }
  
    .app__veranstaltungen_content h1 {
      font-size: 1.5em;
      margin-bottom: 8px;
    }
  
    .app__veranstaltungen_content div {
      font-size: 1.1em;
      margin-bottom: 4px;
    }
    .veranstaltung-intro-title {
      font-size: 1.5em;
    }
    .veranstaltung-intro-text {
      font-size: 1rem;
    
    }
  }
  @media screen and (max-width:450px) {
    .veranstaltung-intro-container {
      padding: 10px;
    }
  }
  @media screen and (max-width:375px) {
    .veranstaltung-intro-container {
      padding: 1px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/container/Veranstaltungen/veranstaltungen.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,YAAY;IACZ,aAAa;AACjB;;EAEE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,sCAAsC;EACxC;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,mCAAmC;IACnC,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,kEAAkE;IAClE,wCAAwC,GAAG,wBAAwB;AACvE;AACA;EACE,2CAA2C,GAAG,wDAAwD;EACtG,wCAAwC,GAAG,gDAAgD;AAC7F;;;AAGA;IACI,qCAAqC,GAAG,iCAAiC;IACzE,uCAAuC,GAAG,iCAAiC;IAC3E,wCAAwC,GAAG,wBAAwB;AACvE;;AAEA;IACI,iCAAiC,GAAG,qEAAqE;IACzG,wCAAwC,GAAG,gCAAgC;AAC/E;;;EAGE;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,+DAA+D;IAC/D,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,0CAA0C;IAC1C,0BAA0B;;EAE5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;;EAE3B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;IACnB,4CAA4C;EAC9C;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA,+BAA+B;AACjC;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,qCAAqC;IACrC,mCAAmC;IACnC,yBAAyB;IACzB,eAAe;EACjB;;EAEA,mCAAmC;EACnC;IACE,aAAa,GAAG,8CAA8C;EAChE;;EAEA,0BAA0B;EAC1B;IACE,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,cAAc;IACd,kCAAkC;IAClC,oBAAoB;IACpB,4BAA4B,EAAE,2BAA2B;EAC3D;EACA,sCAAsC;;EAEtC;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;AACtB;;CAEC,kCAAkC;AACnC;IACI;MACE,aAAa;IACf;;IAEA;MACE,eAAe;MACf,aAAa;MACb,mBAAmB;IACrB;;IAEA;MACE,cAAc;MACd,mBAAmB;IACrB;;IAEA;MACE,cAAc;MACd,iBAAiB;MACjB,YAAY;MACZ,cAAc;IAChB;;IAEA;MACE,mBAAmB;MACnB,aAAa;MACb,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;IACpB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,eAAe;;IAEjB;EACF;EACA;IACE;MACE,aAAa;IACf;EACF;EACA;IACE;MACE,YAAY;IACd;EACF","sourcesContent":[".app__veranstaltungen_main-container {\r\n    max-width: 1200px;\r\n    margin: auto;\r\n    padding: 50px;\r\n}\r\n  \r\n  .app__veranstaltungen_container {\r\n    padding: 30px;\r\n    border-radius: 15px; \r\n  }\r\n  \r\n  .app__veranstaltungen_title {\r\n    font-size: 3rem;\r\n    color: #000000;\r\n    text-align: center;\r\n    font-family: \"SawtonIndustrial-Medium\";\r\n  }\r\n  .app__veranstaltungen_button-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 30px;\r\n  }\r\n  .app__veranstaltungen_button {\r\n    background-color: var(--color-blue);\r\n    color: var(--color-creme);\r\n    border: none;\r\n    padding: 10px 20px;\r\n    text-align: center;\r\n    margin: 15px;\r\n    font-size: 1.2em;\r\n    cursor: pointer;\r\n    border-radius: 15px;\r\n    transition: background-color 0.3s, transform 0.2s, box-shadow 0.2s;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);  /* Schatten hinzufügen */\r\n}\r\n.app__veranstaltungen_button.active {\r\n  background-color: var(--color-little-extra);  /* Ändern Sie die Hintergrundfarbe des aktiven Buttons */\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);  /* Verstärkter Schatten für den aktiven Button */\r\n}\r\n\r\n\r\n.app__veranstaltungen_button:hover {\r\n    background-color: var(--color-marone);  /* Farbänderung beim Überfahren */\r\n    transform: scale(1.04) translateY(-3px);  /* leichtes Anheben des Buttons */\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);  /* Schattenverstärkung */\r\n}\r\n\r\n.app__veranstaltungen_button:active {\r\n    transform: scale(1) translateY(0);  /* Button wird beim Klicken wieder in die Ausgangsposition versetzt */\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);  /* Schatten wird wieder normal */\r\n}\r\n\r\n  \r\n  .app__veranstaltungen_list {\r\n    list-style-type: none;\r\n    padding: 0;\r\n  }\r\n  \r\n  .app__veranstaltungen_item {\r\n    background: linear-gradient(145deg, var(--color-blue), #233749);\r\n    margin-bottom: 20px;\r\n    padding: 20px;\r\n    border-radius: 15px;\r\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\r\n    transition: transform 0.2s;\r\n\r\n  }\r\n  \r\n  .app__veranstaltungen_item:hover {\r\n    transform: translateY(-5px);\r\n  }\r\n  \r\n  .app__veranstaltungen_content {\r\n    color: var(--color-creme);\r\n   \r\n  }\r\n  \r\n  .app__veranstaltungen_content h2 {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    font-size: 1.8em;\r\n    margin-bottom: 10px;\r\n    border-bottom: 3px solid var(--color-marone);\r\n  }\r\n  \r\n  .app__veranstaltungen_content div {\r\n    font-size: 1.3em;\r\n    margin-bottom: 5px;\r\n  }\r\n  /* Stil für das Dropdown-Menü */\r\n.app__veranstaltungen_dropdown {\r\n    width: 100%;\r\n    padding: 10px;\r\n    font-size: 1.2em;\r\n    margin-bottom: 20px;\r\n    border-radius: 15px;\r\n    border: 2px solid var(--color-marone);\r\n    background-color: var(--color-blue);\r\n    color: var(--color-creme);\r\n    cursor: pointer;\r\n  }\r\n  \r\n  /* Für das Pfeil-Icon im Dropdown */\r\n  .app__veranstaltungen_dropdown::-ms-expand {\r\n    display: none;  /* Entfernt den Standardpfeil in IE und Edge */\r\n  }\r\n  \r\n  /* Custom Dropdown Pfeil */\r\n  .app__veranstaltungen_dropdown:after {\r\n    content: '\\25BC';\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    padding: 0 1em;\r\n    background: var(--color-dark-blue);\r\n    pointer-events: none;\r\n    border-radius: 0 15px 15px 0; /* Abrundung an den Ecken */\r\n  }\r\n  /* Styling Intro-Text Veranstaltungen*/\r\n\r\n  .veranstaltung-intro-container {\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.veranstaltung-intro-title {\r\n    font-size: 1.8em;\r\n    color: var(--color-white);\r\n    font-family:\"SawtonCircular-Light\";\r\n    text-align: center;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.veranstaltung-intro-text {\r\n    font-size: 1.2em;\r\n    color: var(--color-white);\r\n    font-family:\"SawtonCircular-Medium\";\r\n    line-height: 1.6;\r\n    text-align: center;\r\n}\r\n\r\n /* Media Queries für Mobilgeräte */\r\n@media screen and (max-width: 768px) {\r\n    .app__veranstaltungen_main-container {\r\n      padding: 20px;\r\n    }\r\n  \r\n    .app__veranstaltungen_container {\r\n      max-width: 100%;\r\n      padding: 20px;\r\n      border-radius: 10px;\r\n    }\r\n  \r\n    .app__veranstaltungen_title {\r\n      font-size: 2em;\r\n      margin-bottom: 20px;\r\n    }\r\n  \r\n    .app__veranstaltungen_button {\r\n      font-size: 1em;\r\n      padding: 8px 20px;\r\n      margin: 10px;\r\n      margin-left: 0;\r\n    }\r\n  \r\n    .app__veranstaltungen_item {\r\n      margin-bottom: 15px;\r\n      padding: 15px;\r\n      border-radius: 10px;\r\n    }\r\n  \r\n    .app__veranstaltungen_content h1 {\r\n      font-size: 1.5em;\r\n      margin-bottom: 8px;\r\n    }\r\n  \r\n    .app__veranstaltungen_content div {\r\n      font-size: 1.1em;\r\n      margin-bottom: 4px;\r\n    }\r\n    .veranstaltung-intro-title {\r\n      font-size: 1.5em;\r\n    }\r\n    .veranstaltung-intro-text {\r\n      font-size: 1rem;\r\n    \r\n    }\r\n  }\r\n  @media screen and (max-width:450px) {\r\n    .veranstaltung-intro-container {\r\n      padding: 10px;\r\n    }\r\n  }\r\n  @media screen and (max-width:375px) {\r\n    .veranstaltung-intro-container {\r\n      padding: 1px;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
